import React, { useEffect, useMemo, useState } from "react";
import {
	AntdButton,
	Container,
	Inner,
	OptionSection,
	SearchContainer,
} from "./styles";
import ProductTable from "../product-table/ProductTable";
import debounce from "lodash/debounce";
import AntdSearch from "../../../../../common/antd-search/AntdSearch";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../../utils/notificationToast";
import { COLORS } from "../../../../../layout/theme";
import { BulbOutlined } from "@ant-design/icons";
import SuggestedProductsModal from "./suggested-products-modal/SuggestedProductsModal";
import { get_pointOfSale_by_userId_dapper } from "../../../../../../api/endpoints/pointsofsale";
import { get_points_of_sale_suggested } from "../../../../../../api/endpoints/laboratorySuggestions";

export default function AddProducts({
	templateProducts,
	setTemplateProducts,
	laboratoryId,
	clientInfo,
}) {
	const [loading, setLoading] = useState(false);
	const [searchByStore, setSearchByStore] = useState(null);
	const [listedProducts, setListedProducts] = useState(templateProducts);
	const [showSuggestedModal, setShowSuggestedModal] = useState(false);

	function updateQuantities(baseArray, updatesArray) {
		const updatesMap = new Map(
			updatesArray.map((item) => [item.id, item.quantity]),
		);

		const updatedProducts = baseArray.map((item) => {
			if (updatesMap.has(item.id)) {
				return { ...item, quantity: updatesMap.get(item.id) };
			}
			return item;
		});

		setTemplateProducts(updatedProducts);
	}

	const handleTableChange = (values) => {
		const updatedProducts = listedProducts.map((product, index) =>
			product.id === values.id
				? { ...product, quantity: parseInt(values.value), hasChanges: true }
				: product,
		);

		updateQuantities(templateProducts, updatedProducts);
		setListedProducts(updatedProducts);
	};

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		const searchValue = e.target.value.toLowerCase();
		setSearchByStore(searchValue);
		if (!searchValue) {
			updateQuantities(templateProducts, listedProducts);
			setListedProducts(templateProducts);
		} else {
			const filteredProducts = templateProducts.filter(
				(product) =>
					product.title.toLowerCase().includes(searchValue) ||
					product.ean13.includes(searchValue),
			);
			setListedProducts(filteredProducts);
		}
	};

	const debouncedEventHandler = useMemo(
		() => debounce(eventHandler, 600),
		[templateProducts, listedProducts],
	);

	function updateQuantitiesFromSuggested(baseArray, suggestedArray) {
		const updatesMap = new Map(
			suggestedArray.map((item) => [
				String(item.id || item.productId),
				Number(item.quantity),
			]),
		);

		const updatedProducts = baseArray.map((item) => {
			const productId = String(item.id || item.productId);

			if (updatesMap.has(productId)) {
				return {
					...item,
					quantity: updatesMap.get(productId),
					hasChanges: true,
				};
			}

			return item;
		});

		setTemplateProducts(updatedProducts);
		setListedProducts(updatedProducts);
	}

	const handleShowSuggestedModal = () => {
		setSearchByStore(null);
		updateQuantities(templateProducts, listedProducts);
		setListedProducts(templateProducts);
		setShowSuggestedModal(true);
	};

	const handleSuggestedModalClose = () => {
		setShowSuggestedModal(false);
	};

	const handleAcceptSuggestedProducts = (products) => {
		updateQuantitiesFromSuggested(templateProducts, products);

		openNotificationWithIcon(
			TYPE.SUCCESS,
			"Productos sugeridos agregados",
			"Se agregaron los productos sugeridos a la lista",
		);
	};

	return (
		<Inner>
			<OptionSection>
				<SearchContainer>
					<AntdSearch
						allowClear
						placeholder="Buscar productos"
						width={459}
						onChange={(e) => {
							setSearchByStore(e.target.value);
							debouncedEventHandler(e);
						}}
						value={searchByStore}
						// onPressEnter={(e) => debouncedEventHandler(e)}
						disabled={loading}
					/>
				</SearchContainer>
				<AntdButton
					color={COLORS.White}
					backgroundColor={COLORS.Secondary}
					borderColor={COLORS.Secondary}
					hoverColor={COLORS.Secondary}
					onClick={handleShowSuggestedModal}
					disabled={loading}
				>
					<BulbOutlined /> Ver sugeridos
				</AntdButton>
				<SuggestedProductsModal
					open={showSuggestedModal}
					onClose={handleSuggestedModalClose}
					laboratoryId={laboratoryId}
					clientInfo={clientInfo}
					fetchPointsOfSale={get_pointOfSale_by_userId_dapper}
					fetchSuggestedByPointOfSale={get_points_of_sale_suggested}
					onAccept={handleAcceptSuggestedProducts}
				/>
			</OptionSection>
			<Container>
				<ProductTable data={listedProducts} onChange={handleTableChange} />
			</Container>
		</Inner>
	);
}
